export enum BreathingButton {
  begin = "begin",
  anotherExercise = "anotherExercise",
  bellyBreathing = "bellyBreathing",
  fourSevenEightBreathing = "fourSevenEightBreathing",
  rollBreathing = "rollBreathing",
}
